import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import 'swiper/swiper-bundle.css';

const initializePageMidia = () => {
    const pageMidia = document.getElementById("naMidia");
    if (!pageMidia) return;

    initializeDropdownCategoria();
};

// ========== Função para Dropdown de Categorias ========== 
const initializeDropdownCategoria = () => {
    const pageMidia = document.getElementById("naMidia");
    if (!pageMidia) return;

    const dropdownMidia = pageMidia.querySelector(".dropdown-midia");
    if (!dropdownMidia) return;

    const buttonMidia = dropdownMidia.querySelector(".dropdown-midia-button");
    const menuMidia = dropdownMidia.querySelector(".dropdown-midia-menu");

    if (!buttonMidia || !menuMidia) return;

    // Evento de clique apenas para o dropdown dentro de #naMidia
    buttonMidia.addEventListener("click", function (event) {
        event.stopPropagation();
        menuMidia.classList.toggle("hidden");
    });

    // Fecha apenas o dropdown atual ao clicar fora
    document.addEventListener("click", function (event) {
        if (!event.target.closest(".dropdown-midia")) {
            menuMidia.classList.add("hidden");
        }
    });
};

// Exportação correta para ser importada no `main.js`
export default initializePageMidia;
